import { render, staticRenderFns } from "./ShopAddressData.vue?vue&type=template&id=8a3ccbb2&"
import script from "./ShopAddressData.vue?vue&type=script&lang=js&"
export * from "./ShopAddressData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports